import { Font, StyleSheet } from "@react-pdf/renderer";

Font.register({
  family: "Exo2 Regular",
  fonts: [
    {
      src: "/FontApp/Exo2-Regular.ttf",
    },
  ],
});

Font.register({
  family: "Exo2 Medium",
  fonts: [
    {
      src: "/FontApp/Exo2-Medium.ttf",
    },
  ],
});

Font.register({
  family: "Exo2 Light",
  fonts: [
    {
      src: "/FontApp/Exo2-Light.ttf",
    },
  ],
});

export const StylesPDF = StyleSheet.create({
  Header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 20,
  },
  Logo: {
    display: "flex",
    flexDirection: "row",
  },
  LogoText: {
    color: "#000",
    fontSize: 20,
    fontFamily: "Exo2 Medium",
  },
  LogoTextColor: {
    color: "#1AC63F",
    fontWeight: "bold",
    fontSize: 20,
    fontFamily: "Exo2 Medium",
  },
  TaskInfoTitle: {
    fontFamily: "Exo2 Regular",
    fontSize: 20,
  },
  NameCreatorTaskContainer: {
    display: "flex",
    flexDirection: "row",
    marginLeft: 16,
    marginTop: 50,
  },
  NameCreatorColor: {
    fontFamily: "Exo2 Medium",
    fontSize: 20,
    color: "#1A50C6",
  },
  NameCreatorText: {
    fontFamily: "Exo2 Medium",
    fontSize: 20,
    color: "#000",
  },
  ContainerData: {
    display: "flex",
    flexDirection: "row",
    gap: 40,
    marginLeft: 16,
    marginTop: 20,
  },
  SelectedContainer: {
    display: "flex",
    flexDirection: "column",
  },
  SelectedTitle: {
    fontFamily: "Exo2 Light",
    fontSize: 16,
  },
  taskDateTime: {
    fontFamily: "Exo2 Light",
    fontSize: 16,
  },
});
